import axios from 'axios';
import base from '@/api/base.api';
const namespace = 'custom-models/generator';

export default {
    all: (params, onSuccess, onError) => {
        return axios.post(`${base.baseUrl}/${namespace}/list-all`, params).then(onSuccess).catch(onError);
    }
}
